import styled from 'styled-components';

const ArticlePageHolder = styled.div`
	grid-area: content;
	padding: 0 0 25px 0;
	overflow: auto;
	p {
		background-color: transparent !important;
	}
	.iframe-container {
		position: relative;
		padding-bottom: 56.25%;
		height: 0;
		overflow: hidden;
		max-width: 100%;
		iframe, object, embed {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
	.twitter-tweet {
		margin-left:auto;margin-right:auto;
	}
	.row {
		clear: both;
		display: flex;
		justify-content: space-around;
		flex-flow: row;
		align-items: stretch;
	}
	a {
		color: #7a7652;
		text-decoration: none;
		touch-action: manipulation;
	}
	h1 {
		font-family: "Quicksand", sans-serif;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.2;
		background-color: #726b55;
		color: #fdfdfc;
		text-align:left !important;
		width: 100%;
		padding: 12px;
		margin: 0;
	}
	span {
		&.content-title {
			@media only screen and (max-width: 767px) {
				font-size: 1.3rem;
			}
			color: #383838;
			font-size: 2.5rem;
			margin-top: 1rem;
			font-weight: 500;
			line-height: 1.2;
		}
	}
	.hn__content {
		ul {
			grid-template-columns: repeat(2,1fr);
			@media (max-width: 767px) {
				grid-template-columns: 1fr;
			}
		}
		li {
			min-height: 300px;
			.description__container {
				@media (max-width: 767px) {
					padding-bottom: 0 !important;
				}
			}

		}
	}
	.article-bg {
    	margin: 80px auto;
		background-color: rgba(255, 255, 255, 0.2);
		border-radius: 20px;
		@media (min-width: 767px) {
			max-width: 60%;
		}
		@media (max-width: 1024px) {
			padding: 30px;
		}
		@media (min-width: 1025px) {
			padding: 65px;
		}
		.article-hero-contain {
			width: 100%;
			min-height: 0;
			padding: 0;
		}
		.article-hero {
			display:flex;
			flex-flow: row nowrap;
			align-items:center;
			justify-content:center;
			position:relative;
		}
		.article-hero-image-block {
			img {
				width: 100%;
				margin-top:1.25rem;
				vertical-align:middle;
				border-radius: 20px 20px 0px 0px;
			}
		}
		.entry-content {
			hr {
				margin: 1rem 0;
				border: 0;
				border-top: 1px solid rgba(0, 0, 0, 0.1);
				height:0;
				overflow: visible;
				box-sizing: content-box;
			}	
			@media (max-width: 767px) {
				padding-left: .8rem;
				padding-right: .8rem;
			}
			.share-container { 
				margin: 3rem 0;
			}
			.article_content {
				padding-top: 1.rem;
			}
		}	
		.article-cpac-item-list {
			@media (max-width: 767px) {
				padding: 0 0;
			}
		}
		.article-tag-container {
			margin: 0 auto;
			hr {
				margin-top: 1rem;
				margin-bottom: 1rem;
				border: 0;
				border-top: 1px solid rgba(0, 0, 0, 0.1);
			}
			a {
				display: block;
				.article-tag {
					margin: 20px 5px;
					.tag-icon {
						height: 20px;
						width: 20px;
						filter: invert(.7) sepia(.5) brightness(95%);
						margin: 0 5px -3px 0;
						transform: rotate(270deg);
					}
				}
			}
		}
		.translation-msg p {
			font-weight: 400;
			font-size: 1rem;
			text-align: center;
		}
	}
`;

export default ArticlePageHolder;